module.exports = __webpack_public_path__ + "static/media/amethysthero.5c38cae3.jpg";